import { GridRowClassNameParams } from '@mui/x-data-grid-premium'

export const getNcoRowClassNames = (params: GridRowClassNameParams, isDrawerOpen: boolean) => {
  const classes: string[] = []
  if (isDrawerOpen) classes.push('has-drawer-open')
  if (params?.row?.isProduct) classes.push('product-row')

  return classes.join(' ')
}
